<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/groups">{{ $t('remind_ar_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('remind_ar_create')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <!--<div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.date.required">- សូមជ្រើរើសកាលបរិច្ចេទ</div>
                        <div class="error" v-if="!$v.model.CurrencyCode.required">- សូមធ្វើការជ្រើរើសប្រភេទរូបិយប័ណ្ណ</div>
                        <div class="error" v-if="!$v.model.Value.required">- សូមធ្វើកាបញ្ចូលតម្លៃ</div>
                    </div>-->
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <input type="hidden" class="form-control form-control-sm"/>
                            </div>
                            <div class="form-group">
                                <label class="label-control">{{$t('remind_ar_name')}}</label>
                                <input type="text" class="form-control form-control-sm"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>